import React, {FC} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikRowInput} from "@components/panel/formik";
import {ItemInput} from "@components/consumer/helpers";
import {GoalRewardType} from "@interfaces/consumer/refs";
import {GoalRewardFormValues} from "./rewardBaseInfoBlock";

const RewardContentBlock: FC = () => {
    const {values, setFieldValue, errors} = useFormikContext<GoalRewardFormValues>();

    const title = values.type === GoalRewardType.Balance ? "Сумма награды" : "Предмет";

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">{title}</Card.Header>
            <Card.Body>
                {values.type === GoalRewardType.Balance ? (
                    <Field
                        label="Сумма"
                        name="balance"
                        type="number"
                        component={FormikRowInput}
                    />
                ) : (
                    <>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Предмет</Form.Label>
                            <Col sm={9}>
                                <ItemInput
                                    name="itemId"
                                    value={values.itemId || ''}
                                    setFieldValue={setFieldValue}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.itemId}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>

                        <Field
                            label="Количество"
                            name="count"
                            type="number"
                            component={FormikRowInput}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default RewardContentBlock;
